import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import API from '../services/api';
import { toast } from 'react-toastify';

const Signup = () => {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '', dob: '', gender: 'male' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const update = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (step === 1) { setStep(2); return; }
    setLoading(true);
    try {
      const res = await API.post('/auth/register', form);
      localStorage.setItem('vibe_token', res.data.token);
      localStorage.setItem('vibe_user', JSON.stringify(res.data.user));
      toast.success('Account created!');
      navigate('/profile-setup');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Registration failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      background: '#08080C', position: 'relative', overflow: 'hidden',
    }}>
      <div style={{ position: 'absolute', top: -80, left: -80, width: 250, height: 250, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(139,92,246,0.1), transparent)', filter: 'blur(60px)' }} />

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '60px 28px 40px', justifyContent: 'center' }}>
        <div style={{ marginBottom: 32 }}>
          <h1 style={{ fontSize: 34, fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 8 }}>
            {step === 1 ? 'Create account' : 'Tell us about you'}
          </h1>
          <p style={{ fontSize: 15, color: '#71717A' }}>
            {step === 1 ? 'Start your vibe journey' : 'Almost there, let\'s set up your profile'}
          </p>
        </div>

        <div style={{ display: 'flex', gap: 6, marginBottom: 28 }}>
          {[1, 2].map(s => (
            <div key={s} style={{ flex: 1, height: 3, borderRadius: 2,
              background: s <= step ? 'linear-gradient(135deg, #FF3D71, #8B5CF6)' : 'rgba(255,255,255,0.06)' }} />
          ))}
        </div>

        <form onSubmit={handleSubmit}>
          {step === 1 ? (
            <>
              <Input label="Full Name" value={form.name} onChange={e => update('name', e.target.value)}
                placeholder="Your name" />
              <Input label="Email" type="email" value={form.email} onChange={e => update('email', e.target.value)}
                placeholder="you@example.com" />
              <Input label="Password" type="password" value={form.password} onChange={e => update('password', e.target.value)}
                placeholder="Create a strong password" />
            </>
          ) : (
            <>
              <Input label="Phone Number" type="tel" value={form.phone} onChange={e => update('phone', e.target.value)}
                placeholder="+91 98765 43210" />
              <Input label="Date of Birth" type="date" value={form.dob} onChange={e => update('dob', e.target.value)} />
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#A1A1AA', marginBottom: 8 }}>Gender</label>
                <div style={{ display: 'flex', gap: 10 }}>
                  {['male', 'female', 'other'].map(g => (
                    <button key={g} type="button" onClick={() => update('gender', g)} style={{
                      flex: 1, padding: '14px', borderRadius: 14,
                      background: form.gender === g ? 'rgba(255,61,113,0.12)' : 'rgba(255,255,255,0.04)',
                      border: `1px solid ${form.gender === g ? 'rgba(255,61,113,0.4)' : 'rgba(255,255,255,0.06)'}`,
                      color: form.gender === g ? '#FF3D71' : '#A1A1AA',
                      fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: 'Inter',
                      textTransform: 'capitalize', transition: 'all 0.2s',
                    }}>{g}</button>
                  ))}
                </div>
              </div>
            </>
          )}
          <Button type="submit" fullWidth size="lg" disabled={loading} style={{ marginTop: 8 }}>
            {step === 1 ? 'Continue' : loading ? 'Creating...' : 'Create Account'}
          </Button>
        </form>

        {step === 2 && (
          <button onClick={() => setStep(1)} style={{
            marginTop: 16, background: 'none', border: 'none', color: '#71717A',
            fontSize: 14, cursor: 'pointer', fontFamily: 'Inter', width: '100%', textAlign: 'center',
          }}>← Back</button>
        )}
      </div>

      <p style={{ textAlign: 'center', padding: '0 28px 32px', fontSize: 14, color: '#71717A' }}>
        Already have an account? <Link to="/login" style={{ color: '#FF3D71', fontWeight: 600 }}> Sign In</Link>
      </p>
    </div>
  );
};

export default Signup;
